import { render, staticRenderFns } from "./InvitationCapture.vue?vue&type=template&id=483adfd3&scoped=true&"
import script from "./InvitationCapture.vue?vue&type=script&lang=js&"
export * from "./InvitationCapture.vue?vue&type=script&lang=js&"
import style0 from "./InvitationCapture.vue?vue&type=style&index=0&id=483adfd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483adfd3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField})
